export enum BackOfficeEnum {
    Passenger2W = 1,
    Passenger3W = 2,
    Passenger4W = 3,
    Delivery2W = 4,
    Delivery3W = 5,
	Delivery4W = 6,
	Taxi = 7,
	ConneX = 8
}
